/**
 * One selectable funding-source type in the picker: a toggle card with a check circle. Moved from
 * guided planning's asset step with its markup unchanged so both flows render it identically.
 */
import { Check } from 'lucide-react';

import { cn } from '@client/lib';

import type { AssetTypeId } from '../config/funding-source-types';

interface FundingSourceCardProps {
  id: AssetTypeId;
  label: string;
  isSelected: boolean;
  onToggle: (id: AssetTypeId) => void;
  disabled?: boolean;
}

export function FundingSourceCard({
  id,
  label,
  isSelected,
  onToggle,
  disabled,
}: FundingSourceCardProps) {
  return (
    <button
      type="button"
      onClick={() => !disabled && onToggle(id)}
      disabled={disabled}
      className={cn(
        'relative flex items-center gap-3 rounded-xl border-2 p-4 text-left transition-all duration-200',
        disabled ? 'cursor-not-allowed opacity-60' : 'hover:border-primary/50 hover:bg-primary/5',
        isSelected ? 'border-primary bg-primary/5' : 'border-gray-200 bg-white',
      )}
    >
      <div
        className={cn(
          'flex size-6 shrink-0 items-center justify-center rounded-full border-2 transition-all duration-200',
          isSelected ? 'border-primary bg-primary text-white' : 'border-gray-300 bg-white',
        )}
      >
        {isSelected && <Check className="size-4" />}
      </div>
      <span className="font-medium text-gray-900">{label}</span>
    </button>
  );
}
